import React from 'react';
export const MoodMixCard = ({
  onClick,
  isFirstTime = false
}) => {
  return <div onClick={onClick} className={`
        relative bg-[#181818] rounded-xl p-4 hover:bg-[#282828] 
        transition-colors cursor-pointer group
        ${isFirstTime ? 'animate-pulse-border' : ''}
      `} data-id="element-224">
      <div className="relative mb-4" data-id="element-225">
        <div className="w-full aspect-square rounded-xl overflow-hidden bg-gradient-to-br from-purple-600 via-blue-500 to-green-400" data-id="element-226">
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-227">
            <div className="w-12 h-12 text-white" data-id="element-228" />
          </div>
        </div>
        <div className="absolute bottom-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-229">
          <div className="bg-green-500 rounded-full p-3 shadow-lg" data-id="element-230">
            <svg className="w-6 h-6 text-black" fill="currentColor" viewBox="0 0 24 24" data-id="element-231">
              <path d="M8 5v14l11-7z" data-id="element-232" />
            </svg>
          </div>
        </div>
      </div>
      <h3 className="font-bold text-base mb-1" data-id="element-233">🌀 Create Your Mood Mix</h3>
      <p className="text-gray-400 text-sm" data-id="element-234">
        Describe how you feel. Get a playlist that gets you.
      </p>
    </div>;
};